<template>
<b-container fluid>
  <b-container class="p-1 d-none d-lg-block">
    <b-row class="justify-content-md-center p-0 m-0">
      <b-col cols="12" class="p-2">
        <b-card class="bg-transparent border-0 p-0">
          <slot name="p-1"/>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center p-0 m-0">
      <b-row class="justify-content-md-center ">
        <b-col lg="6" md="6" sm="12" class="p-2">
          <b-card class="bg-transparent border-0 p-0">
            <slot name="p-2"/>
          </b-card>
        </b-col>
        <b-col lg="6" md="6" sm="12" class="p-2">
          <b-card class="bg-transparent border-0 p-0">
            <slot name="p-3"/>
          </b-card>
        </b-col>
      </b-row>
    </b-row>
  </b-container>
  <b-container class="p-1 d-lg-none">
    <b-row class="justify-content-md-center p-0 m-0">
      <b-row class="justify-content-md-center ">
        <b-col cols="4" class="p-2">
          <b-card class="bg-transparent border-0 p-0">
            <slot name="p-4"/>
          </b-card>
        </b-col>
        <b-col cols="4" class="p-2">
          <b-card class="bg-transparent border-0 p-0">
            <slot name="p-5"/>
          </b-card>
        </b-col>
        <b-col cols="4" class="p-2">
          <b-card class="bg-transparent border-0 p-0">
            <slot name="p-6"/>
          </b-card>
        </b-col>
      </b-row>
    </b-row>
  </b-container>
</b-container>
</template>

<script>
export default {
  name: "S102"
}
</script>

<style scoped>
.card-body{
  padding: 0;
  margin: 0;
}
</style>